var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{class:_vm.messageClass,domProps:{"innerHTML":_vm._s(_vm.value)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }